//Converts database string to a normalized document
export function denormalize(value: string) {
  const [type, number] = value.split(":");
  return {
    type: (type as "CI" | "OTHER") || "CI",
    number: number ? (type === "CI" ? formatCI(number) : number) : "",
  };
}

//Converts a normalized document to a string
export function normalize(value: { type: string; number: string }) {
  if (value.type === "CI") value.number = value.number.replace(/\D/g, "");
  else value.number = value.number.toUpperCase().replace(/[^0-9A-Z-/\.]/g, "");
  return `${value.type}:${value.number}`;
}

function formatCI(input: string) {
  if (!input) return input;
  const chars = Array.from(input.replace(/\D/g, ""));
  if (chars.length < 2) return chars.join("");
  chars.splice(-1, 0, "-");
  if (chars.length > 5) chars.splice(-5, 0, ".");
  if (chars.length > 9) chars.splice(-9, 0, ".");
  return chars.join("");
}
